import {Injectable} from '@angular/core';
import {SubscriptionsService} from './subscriptions.service';
import {take} from 'rxjs/operators';
import {GameLauncherService} from './game-launcher.service';

@Injectable({
  providedIn: 'root'
})
export class ReloadGameService {
  element: HTMLElement;
  iFrame: any;
  targetOrigin: string;
  source: any;
  gameId: any;
  gameBackground: string;
  constructor(public subscriptionsService: SubscriptionsService, public gameLauncher: GameLauncherService,) {
    window.addEventListener('message', (e) => {
       if (e.origin.includes('playngonetwork.com')) {
         if (e.data.type === 'backToLobby' || e.data.type === 'logout' || e.data.type === 'gameDisabled') {
           this.subscriptionsService.reloadGame.next(true);
         } else if (e.data.type === 'reloadGame') {
           if (localStorage.getItem('gameBackground')) {
             this.gameBackground = localStorage.getItem('gameBackground');
           }
           this.subscriptionsService.getIfGameClose().pipe(take(1)).subscribe(val => {
             if (val === true) {
               setTimeout(() => {
                 this.subscriptionsService.emitGameBackground(this.gameBackground);
                 this.gameLauncher.runGame(this.gameId, 0);
               }, 2000);
             }
           });
           this.subscriptionsService.reloadGame.next(true);
         }
       }
    });
  }

  gameListener(url, gameId) {
    if (url.includes('playngonetwork')) {
      this.gameId = gameId;
      setTimeout(() => {
        this.iFrame = document.getElementById('game-iframe') as HTMLIFrameElement;
        this.targetOrigin = '*';
        this.source = this.iFrame.contentWindow;
      }, 3000);
      setTimeout(() => {
        this.postMessage({messageType: 'addEventListener', eventType: 'backToLobby'});
        this.postMessage({messageType: 'addEventListener', eventType: 'gameDisable'});
        this.postMessage({messageType: 'addEventListener', eventType: 'logout'});
        this.postMessage({messageType: 'addEventListener', eventType: 'reloadGame'});
      }, 5000);
    }
  }

  postMessage(data) {
    this.source.postMessage(data, this.targetOrigin);
  }
}
